import { QuizDefault } from 'icons';
import { useTranslation } from 'react-i18next';

import { Button, Card, CardContent, Typography } from '@cfa/react-components';

import { itemByLanguage } from '@/utils/language';

import { mapCategoryToColor } from 'utils/categoryUtils';

import { CustomQuizDto } from '@/_generated/api-clients/xp';

interface QuizLibraryCardProps {
  onAddQuiz: (quiz: CustomQuizDto) => void;
  onPreviewQuiz: (quiz: CustomQuizDto) => void;
  quiz: CustomQuizDto;
  quizAddButtonTestId: string;
  quizNameTestId: string;
}

const QuizLibraryCard: React.FC<QuizLibraryCardProps> = ({
  onAddQuiz,
  onPreviewQuiz,
  quiz,
  quizAddButtonTestId,
  quizNameTestId,
}) => {
  const { t } = useTranslation();
  const quizName = itemByLanguage(quiz.name);
  const imgClasses = `rounded-tl-inherit rounded-bl-inherit flex h-auto flex-shrink-0 items-center justify-center px-4 py-6`;

  return (
    <Card className="animate-fadeIn! linear! quizCard relative! my-2! flex! h-auto! flex-row! overflow-visible! p-0! duration-300!">
      <div
        className={imgClasses}
        style={{ backgroundColor: mapCategoryToColor('default') }}
      >
        <QuizDefault />
      </div>
      <CardContent className="flex w-full flex-col items-start justify-between p-4! md:flex-row md:items-center">
        <div className="mr-4 overflow-hidden text-left">
          <Typography
            className="line-clamp-2 max-w-full min-w-0 overflow-hidden text-left! font-medium text-ellipsis"
            data-testid={quizNameTestId}
          >
            {quizName}
          </Typography>
        </div>
        <div className="flex w-full items-center justify-start gap-4 pt-4 md:w-auto md:justify-center md:pt-0">
          <Button
            className="min-w-[unset]!"
            color="secondary"
            data-testid={'quizPreviewButtonTest'}
            onClick={() => onPreviewQuiz(quiz)}
            variant="outlined"
          >
            {t('Button.preview')}
          </Button>
          <Button
            className="min-w-[unset]!"
            color="secondary"
            data-testid={quizAddButtonTestId}
            onClick={() => onAddQuiz(quiz)}
            variant="filled"
          >
            {t('Button.add')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuizLibraryCard;
